import { useTranslation } from 'i18n';

/** R6 food: "No onions · + Cheese" under a cart/order line. Accepts both the
 * cart/order snapshot shape (addons as {name, price}) and the request shape. */
export default function ModifiersNote({ modifiers, invalid = false, className = '', variant = null, variantInvalid = false, booking = null }) {
  const { t } = useTranslation();
  // Services: the requested date / window / notes.
  const bookingText = booking ? [booking.date, booking.window ? t(`listing.window.${booking.window}`) : null, booking.notes]
    .filter(Boolean).join(' · ') : '';
  // Variants: "White / M" under the line (cart, checkout, orders, invoices).
  const variantLine = variantInvalid ? (
    <p className={`text-xs font-medium text-danger ${className}`} data-testid="variant-invalid">{t('variants.optionUnavailable')}</p>
  ) : variant || bookingText ? (
    <>
      {variant && <p className={`text-xs text-slate-500 ${className}`} data-testid="variant-note">{variant}</p>}
      {bookingText && <p className={`text-xs text-slate-500 ${className}`} data-testid="booking-note">{bookingText}</p>}
    </>
  ) : null;
  if (invalid) {
    return <>{variantLine}<p className={`text-xs font-medium text-danger ${className}`} data-testid="modifiers-invalid">{t('modules.food.optionsChanged')}</p></>;
  }
  const parts = modifiers ? [
    ...(modifiers.remove || []).map((r) => t('modules.food.without', { item: r })),
    ...(modifiers.addons || []).map((a) => `+ ${typeof a === 'string' ? a : a.name}`),
  ] : [];
  if (!parts.length) return variantLine;
  return <>{variantLine}<p className={`text-xs text-slate-500 ${className}`} data-testid="modifiers-note">{parts.join(' · ')}</p></>;
}

/** Unit price of a cart line: the server's unit_price (with add-ons) when present. */
export function lineUnitPrice(item) {
  return Number(item?.unit_price ?? item?.product?.price ?? item?.price ?? 0);
}
